import { useSelector } from 'react-redux';
import { useSystemSettings } from './useSystemSettings';
import { selectUserPreferences } from '../store/preferencesSlice';

/**
 * Single resolver for the redesigned GUI (docs/design/). Components should
 * branch on this instead of reading NEW_GUI_ENABLED or the user preference
 * directly, so the on/off decision stays in one place.
 *
 * Effective new-GUI only when the superadmin-controlled system setting is on
 * AND the signed-in user has opted in via their preferences.
 */
export function useNewGui(): boolean {
    const { settings } = useSystemSettings();
    const preferences = useSelector(selectUserPreferences);

    return settings.NEW_GUI_ENABLED === 'true' && preferences.useNewGui === true;
}
